import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AlloyService } from 'src/app/shared/alloy/alloy.service';
import { LoginService } from 'src/app/shared/user-login/login.service';

@Component({
    selector: 'app-standard-alloys',
    templateUrl: './standard-alloys.component.html',
    styleUrls: ['./standard-alloys.component.css'],
    standalone: false
})
export class StandardAlloysComponent implements OnInit {
  alloys: []
  role: string;
  serverErrorMessages: string
  loading:boolean=true

  constructor(private loginService: LoginService, private alloyService: AlloyService, private router : Router) { }

  ngOnInit(): void {
    if (this.loginService.shouldBlock()) {
      alert('Low Balance! Redirecting...');
      this.router.navigateByUrl('/home');
    }
    if(this.loginService.isLoggedIn()){
      this.loginService.getUserProfile().subscribe(
        res => {
          this.role = res['user'].role.toString();
         //console.log('User', this.role);
          // this.loading = false;
          this.getStandardAlloys();
        },
        err => {
         //console.log('Didnt get logged in user', err);
          this.serverErrorMessages = err.error.message;
          // this.loading = false;
        }
      )

    }
  }

  unauthorised(){
    setTimeout(() => {
      this.loginService.deleteToken();
     //console.log('BYE BYE');
      this.router.navigateByUrl('/signin');
    }, 3000);
  }

  getStandardAlloys(){
    this.alloyService.getStandardAlloys().subscribe(
      res => {
        this.alloys = res['standardAlloys'];
       //console.log('Got standard alloys', this.alloys)
        this.loading=false;
      },
      err=>{
       //console.log('Error getting standard alloys', err);
        this.serverErrorMessages = err.error.message
      }
    )
  }

}

